import { graphql } from 'src/graphql';

export const FetchChatFollowups = graphql(`
  query FetchChatFollowupsQuery($chatId: ID!) {
    chatFollowups(chatId: $chatId) {
      suggestions
    }
  }
`);
